import { Alert, AlertColor, Snackbar } from "@mui/material";
import { useState } from "react";

export interface AlertBoxProps {
  alertMessage: string | null,
  severity?: AlertColor;
  autoHideDuration?: number | null;
}
const alertStyle = {
  '.MuiAlert-message': {
    padding: "4px 0"
  },
};

export const AlertBox = ({alertMessage, severity, autoHideDuration}: AlertBoxProps) => {
  const [openAlert, setOpenAlert] = useState<boolean>(true);

  return (
    <Snackbar
      open={openAlert}
      autoHideDuration={autoHideDuration}
      onClose={() => setOpenAlert(false)}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <Alert
        onClose={() => setOpenAlert(false)}
        severity={severity}
        variant="filled"
        sx={alertStyle}
      >
        {alertMessage}
      </Alert>
    </Snackbar>
  );
};